import { render } from "./small-boxes-component.vue?vue&type=template&id=7c4bfeeb&scoped=true"
import script from "./small-boxes-component.vue?vue&type=script&lang=js"
export * from "./small-boxes-component.vue?vue&type=script&lang=js"

import "./small-boxes-component.vue?vue&type=style&index=0&id=7c4bfeeb&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4bfeeb"],['__file',"src/assets/js/vue/components/dashboard/small-boxes-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c4bfeeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c4bfeeb', __exports__)) {
    api.reload('7c4bfeeb', __exports__)
  }
  
  module.hot.accept("./small-boxes-component.vue?vue&type=template&id=7c4bfeeb&scoped=true", () => {
    api.rerender('7c4bfeeb', render)
  })

}


export default __exports__